<div class="topbar">
  <div>
    <h1>Indstillinger for Fabrikater</h1>
  </div>
  <div class="topbar__actions">
    @if (canEdit) {
      <button class="btn-icon green" (click)="add()" matTooltip="Opret fabrikat">
        <mat-icon svgIcon="add"></mat-icon>
        <span>Opret fabrikat</span>
      </button>
    }
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    <table mat-table [dataSource]="fabrikater" class="mat-elevation-z0 settings__table">
      <ng-container matColumnDef="produktId">
        <th mat-header-cell *matHeaderCellDef>Produkt</th>
        <td mat-cell *matCellDef="let row">
          {{ row.produktId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef="let row">
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fabrikatstatus">
        <th mat-header-cell *matHeaderCellDef>Tillad oprettelse</th>
        <td mat-cell *matCellDef="let row">
          {{ fabrikatstatus(row.fabrikatstatus) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="hidden-cell">
            @if (canEdit) {
              <button (click)="edit(row)" class="btn-icon blue" aria-label="Rediger fabrikat" matTooltip="Rediger fabrikat">
                <mat-icon svgIcon="edit"></mat-icon>
              </button>
            }
            <button (click)="addmodel(row)" class="btn-icon blue" aria-label="Tilføj model" matTooltip="Tilføj model">
              <mat-icon>swap_horiz</mat-icon>
            </button>
            <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
              <mat-icon>timeline</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
